import CtaLink from './CtaLink';
import Reveal from '@/components/base/Reveal';

export default function FinalCTA() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-primary-500/20 bg-gradient-to-br from-background-200 to-background-100 p-10 md:p-16 text-center">
            <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-primary-500/10 blur-[120px]" />

            <div className="relative">
              <h2 className="font-heading font-bold text-3xl md:text-5xl text-foreground-950">
                Ready to Turn Marketing Into{' '}
                <span className="text-primary-400">Predictable Growth?</span>
              </h2>
              <p className="mt-5 max-w-2xl mx-auto text-foreground-600 leading-relaxed">
                Whether you need the work done for you or you want strategic
                guidance for your team, Josh can help you build a smarter path
                to more leads, customers, and revenue.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
                <CtaLink>Apply to Work With Me</CtaLink>
                <CtaLink variant="secondary">See If We&rsquo;re a Fit</CtaLink>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
